import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'
import { editorDebug } from '~publish/legacy/editor/editorDebug'
import { withoutLosingSelection } from '~publish/legacy/editor/helpers/withoutLosingSelection'

import { getAllLinkNodes } from '../../link/nodes/getAllLinkNodes'
import { LinkedInAnnotationInputElement } from '../nodes/LinkedInAnnotationInputElement'
import type { LinkedInAnnotationEntityDetails } from '../nodes/LinkedInAnnotationInputElement'

const debug = editorDebug.extend('plugins:linkedin-annotations')

export const insertLinkedInAnnotation = (
  editor: BufferEditor,
  annotation: LinkedInAnnotationEntityDetails,
): void => {
  const allLinks = getAllLinkNodes(editor, { reverse: true })
  const nodesWithEntityUrl = allLinks.filter(
    ([n]) => n.url === annotation.link && !n.isAnnotationProcessed,
  )
  Array.from(nodesWithEntityUrl).forEach(([node, path]) => {
    debug('wrapping LinkedIn annotation: %s at %o', node.url, path)

    withoutLosingSelection(editor, () => {
      // setNodes never touches `children`, and replacing the old link text
      // via select+insertText instead empties the node mid-operation —
      // Slate's core delete logic unwraps an inline element the moment it
      // has zero children, merging the whole annotation back into plain
      // text before the new text can land inside it. Swapping the node
      // outright sidesteps both: it's never briefly childless.
      editor.tf.withoutNormalizing(() => {
        editor.tf.removeNodes({ at: path })
        editor.tf.insertNodes<LinkedInAnnotationInputElement>(
          LinkedInAnnotationInputElement.new(annotation),
          {
            at: path,
          },
        )
      })
    })
  })
}
